import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '@widgets/ui-common/material/material.module';
import { ConnectionComponent } from './connection/connection.component';
import { ErrorComponent } from './error/error.component';
import { FatalComponent } from './fatal/fatal.component';
import { InfoComponent } from './info/info.component';
import { SuccessComponent } from './success/success.component';
import { WarningComponent } from './warning/warning.component';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [ErrorComponent, FatalComponent, InfoComponent, SuccessComponent, WarningComponent, ConnectionComponent],
  entryComponents: [ErrorComponent, FatalComponent, InfoComponent, SuccessComponent, WarningComponent, ConnectionComponent]
})
export class SnackbarModule {}
